// src/language/commonLanguage.js
const commonLanguage = {
  en: {
    ok: 'OK',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    save: 'Save',
    delete: 'Delete',
  },
  mr: {
    ok: 'ठीक आहे',
    confirm: 'पुष्टी करा',
    cancel: 'रद्द करा',
    close: 'बंद करा',
    yes: 'होय',
    no: 'नाही',
    success: 'यशस्वी',
    error: 'त्रुटी',
    warning: 'चेतावणी',
    info: 'माहिती',
    save: 'सेव्ह करा',
    delete: 'काढून टाका',
  },
};

export default commonLanguage;
